module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.caseManagers) ? _c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.actionsLog,
      "no-data-text": "No actions",
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.username))]), _vm._v(" "), _c('td', [(props.item.payload && props.item.payload === 'null') ? _c('v-flex') : _c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('v-flex', {
          attrs: {
            "slot": "header"
          },
          slot: "header"
        }, [_vm._v("show")]), _vm._v(" "), _c('v-card', [_c('v-card-text', {
          staticClass: "grey lighten-3",
          domProps: {
            "innerHTML": _vm._s(_vm.parsedPayload(props.item.payload))
          }
        })], 1)], 1)], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))])]
      }
    }], null, false, 3573952361)
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9253ebc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseActionsLogDataTable.vue
// module id = 1000
// module chunks = 1